import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Step } from '../ConversationSupervisorStep';
import StepZilla from 'react-stepzilla';
import ArrowRight from '@mui/icons-material/ArrowRight';
import { hasSelectedDebtorClaims } from '../../../../store/Selectors';
import PreviousStep from './PreviousStep';

interface InjectedProps {
  jumpToStep?: typeof StepZilla.jumpToStep;
}

interface PropsFromState {
  hasSelectedDebtorClaims: boolean;
}

type ComponentProps = PropsFromState & InjectedProps;

const SendPaymentInformation = (props: ComponentProps) => {
  return (
    <React.Fragment>
      <PreviousStep previousStep={() => props.jumpToStep(Step.Start)} />
      <List>
        <ListItem
          sx={{
            paddingRight: 0,
          }}
          button={true}
          onClick={() => props.jumpToStep(Step.SendDebtOverview)}
        >
          <ListItemText primary='Send totaloversikt' />
          <ArrowRight />
        </ListItem>
        <ListItem
          sx={{
            paddingRight: 0,
          }}
          button={true}
          onClick={() => props.jumpToStep(Step.SendSelectedInvoices)}
        >
          <ListItemText primary='Send betalingsinformasjon' />
          <ArrowRight />
        </ListItem>
      </List>
    </React.Fragment>
  );
}

const mapStateToProps = ({
  debtorClaims,
}: ApplicationState): PropsFromState => ({
  hasSelectedDebtorClaims: hasSelectedDebtorClaims(debtorClaims),
});

export default compose(connect(mapStateToProps))(SendPaymentInformation);
